import { VOD_HOST } from 'config/production';
import { DI } from 'modules';
import React from 'react';
import { Helmet } from 'react-helmet';

export function HelmetWrapper(props) {
  const { live, video, page } = props;
  const pathname = props.router.location.pathname;

  const defaultText = isDescription => {
    switch (page) {
      case 'about':
        return 'About | Ruptly';
      case 'broadcast':
        return 'Broadcasts | Ruptly';
      case 'career':
        return 'Careers | Ruptly';
      case 'pricing':
        return 'Pricing | Ruptly';
      case 'cookies':
        return 'Cookies | Ruptly';
      case 'impressum':
        return 'Impressum | Ruptly';
      case 'planning':
        return 'Planning section | Ruptly';
      case 'privacy':
        return 'Privacy Policy | Ruptly';
      case 'team':
        return 'Team | Ruptly';
      case 'terms':
        return 'Terms of Service | Ruptly';
      case 'dashboard':
        return 'Dashboard | Ruptly';
      case 'videos':
        return 'Videos | Video Ruptly';
      case 'video':
        return `${
          isDescription ? video.description : video.title
        } | Video Ruptly`;
      case 'events':
        return `${isDescription ? live.description : live.title} | Live Ruptly`;
      default:
        return 'Ruptly';
    }
  };

  const title = props['title'] || defaultText();
  const description = props['description'] || defaultText(true);

  return (
    <Helmet
      title={title}
      link={[
        {
          rel: 'canonical',
          href: `${VOD_HOST}${props.canonical ? props.canonical : pathname}`
        }
      ]}
      meta={[
        {
          property: 'title',
          content: title
        },
        {
          name: 'description',
          content: description
        },
        {
          property: 'og:title',
          content: props['og_title'] || title
        },
        {
          property: 'og:description',
          content: props['og_description'] || description
        },
        {
          property: 'og:image',
          content:
            (props.og_image && props.og_image.original.url) ||
            (live && live.image.large_brand.url) ||
            (video && video.selected_preview_image.url)
        },
        {
          property: 'og:image:width',
          content: '578'
        },
        {
          property: 'og:image:height',
          content: '325'
        },
        {
          property: 'twitter:title',
          content: props['twitter_title'] || title
        },
        {
          property: 'twitter:description',
          content: props['twitter_description'] || description
        },
        {
          property: 'twitter:image',
          content:
            (props.og_image && props.og_image.original.url) ||
            (live && live.image.large_brand.url) ||
            (video && video.selected_preview_image.url)
        },
        {
          property: 'twitter:image:width',
          content: '578'
        },
        {
          property: 'twitter:image:height',
          content: '325'
        }
      ]}
    />
  );
}

export default DI(['router'])(HelmetWrapper);
